import dayjs from 'dayjs';
import { DATE_SHORT_YEAR, VALID_AMERICAN_DATE_FORMAT_REGULAR_EXPESSION } from '../../constants';

var _validateMin = function _validateMin(value, options) {
  var {
    min,
    required
  } = options;

  if (!min || !value && !required) {
    return true;
  }

  var dateFromValue = dayjs(value, {
    format: DATE_SHORT_YEAR
  });
  var dateRegex = new RegExp(VALID_AMERICAN_DATE_FORMAT_REGULAR_EXPESSION);
  var castedNumber = Number(value);
  var isNumber = !isNaN(castedNumber);

  if (isNumber) {
    return value >= min;
  } else if (value && dateRegex.test(value) && dateFromValue.isValid()) {
    return !dateFromValue.isBefore(dayjs(min, {
      format: DATE_SHORT_YEAR
    }));
  }

  return true;
};

var _validateMax = function _validateMax(value, options) {
  var {
    max,
    required
  } = options;

  if (!max || !value && !required) {
    return true;
  }

  var dateFromValue = dayjs(value, {
    format: DATE_SHORT_YEAR
  });
  var dateRegex = new RegExp(VALID_AMERICAN_DATE_FORMAT_REGULAR_EXPESSION);
  var castedNumber = Number(value);
  var isNumber = !isNaN(castedNumber);

  if (isNumber) {
    return value <= max;
  } else if (value && dateRegex.test(value) && dateFromValue.isValid()) {
    return !dateFromValue.isAfter(dayjs(max, {
      format: DATE_SHORT_YEAR
    }));
  }

  return true;
};

var _validateMinLength = function _validateMinLength(value, options) {
  var {
    minLength,
    required
  } = options;

  if (!minLength || !value && !required) {
    return true;
  }

  return value.length >= minLength;
};

var _matchTargetValue = function _matchTargetValue(value, options) {
  var {
    targetValue,
    required
  } = options;

  if (!targetValue || !value || !value && !required) {
    return true;
  }

  return value === targetValue;
};

var _validateMaxLength = function _validateMaxLength(value, options) {
  var {
    maxLength,
    required
  } = options;

  if (!maxLength || !value && !required) {
    return true;
  }

  return value.length <= maxLength;
};

var _validateRequired = function _validateRequired(value, options) {
  var {
    required
  } = options;

  if (!required) {
    return true;
  }

  return !!value.trim();
};

var _validatePattern = function _validatePattern(value, options) {
  var {
    pattern,
    required
  } = options;

  if (!pattern || !value && !required) {
    return true;
  }

  var isEmptyAndNotRequired = !required && !value;
  return new RegExp(pattern).test(value) || isEmptyAndNotRequired;
};

var defaultRequiredError = 'Required';
var defaultMinError = 'Invalid min';
var defaultMaxError = 'Invalid max';
var defaultMinLengthError = 'Invalid min length';
var defaultMaxLengthError = 'Invalid max length';
var defaultPatternError = 'Invalid pattern';

var validate = function validate(value, options) {
  // Validate all the things
  // https://i.chzbgr.com/full/6230192128/hF5501CDD/
  var validations = Object.assign({
    min: _validateMin(value, options),
    max: _validateMax(value, options),
    minLength: _validateMinLength(value, options),
    maxLength: _validateMaxLength(value, options),
    required: _validateRequired(value, options),
    pattern: _validatePattern(value, options),
    target: _matchTargetValue(value, options)
  });
  var errorMessages = {
    min: options.minError || defaultMinError,
    max: options.maxError || defaultMaxError,
    minLength: options.minLengthError || defaultMinLengthError,
    maxLength: options.maxLengthError || defaultMaxLengthError,
    required: options.requiredError || defaultRequiredError,
    pattern: options.patternError || defaultPatternError,
    target: options.targetValueError
  };
  var errorState = Object.keys(validations).reduce((newErrorState, key) => {
    var isValid = validations[key];

    if (!isValid) {
      newErrorState[key] = errorMessages[key];
    }

    return newErrorState;
  }, {});
  return errorState;
};

var getCurrentError = function getCurrentError(errors) {
  var errorOrder = ['customError', 'required', 'pattern', 'min', 'max', 'minLength', 'maxLength', 'target'];

  for (var errorType of errorOrder) {
    if (errors[errorType]) {
      return errors[errorType];
    }
  }

  return '';
};

export { validate, getCurrentError };